export const config = {
  title: "Lalo Construction Services | Trusted Construction Services in Oakland, CA",
  meta: {
    description:
      "Lalo Construction Services provides professional, high-quality construction and remodeling solutions in Oakland, CA and surrounding areas.",
    keywords: [
      "Oakland CA construction services",
      "Lalo Construction Services",
      "home remodeling Oakland",
      "construction company Oakland",
      "contractor services California"
    ],
    author: "Lalo Construction Services",
    canonicalUrl: "https://caremodelingsvc.com/",
  },
  sections: {
    header: {
      businessName: "Lalo Construction Services",
    },
    sectionB: {
      heroTitle: "Lalo Construction Services",
      heroSubtitle: "Reliable Construction & Remodeling in Oakland, CA",
      learnAboutText: "Request a Quote",
      phoneNumber: "6506794277",
      phoneLabel: "(650) 679-4277",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1292475721/photo/house-construction-framing-gradating-into-finished-kitchen-build.jpg?s=612x612&w=0&k=20&c=Bej7Uvae4UaukW4kNYlAV9CkjP7-JTYfTNuCpB49x88=",
      cardData: [
        {
          title: "New Construction",
          description: "Professional construction services for residential and commercial properties.",
        },
        {
          title: "Remodeling & Renovation",
          description: "Upgrade your space with our expert remodeling services.",
        },
        {
          title: "Custom Projects",
          description: "Tailored construction projects to bring your vision to life.",
        },
      ],
      description:
        "Lalo Construction Services offers a full range of construction and remodeling solutions throughout Oakland, CA, committed to craftsmanship and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We specialize in comprehensive construction services designed to meet your unique needs.",
      cards: [
        {
          title: "Residential Construction",
          description: "From foundations to finish, we build homes you’ll love.",
          imageSrc: "https://media.istockphoto.com/id/2167986788/photo/construction-crew-putting-up-framing-of-new-home.jpg?s=612x612&w=0&k=20&c=PmoyuOSrfFNh7cCUUS8gkmcoQ24jhaOTSrShw_Buobc=",
          imageAlt: "Residential Construction",
        },
        {
          title: "Remodeling & Additions",
          description: "Transform your property with modern upgrades.",
          imageSrc: "https://media.istockphoto.com/id/1096653940/photo/looking-up-the-rough-framing-of-a-residential-additions-roof.jpg?s=612x612&w=0&k=20&c=oIEiXCccTubKLs4Lj05L4c6rAcCvc2ccsfrbXCq9GcI=",
          imageAlt: "Remodeling and Additions",
        },
        {
          title: "Custom Design Services",
          description: "Work with our team to create a custom plan that fits your vision.",
          imageSrc: "https://media.istockphoto.com/id/2169277957/photo/construction-crew-putting-up-framing-of-new-home.jpg?s=612x612&w=0&k=20&c=efE3DmREu2vxaeRZ7uJhrNyW8ggNDqUL8_Cv30koYWI=",
          imageAlt: "Custom Design",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Experienced Team",
        "Top-Quality Materials",
        "Affordable Pricing",
        "Attention to Detail",
        "Customer-Focused Approach",
      ],
    },
    sectionD: {
      aboutTitle: "About Lalo Construction Services",
      aboutImage: {
        src: "https://caremodelingsvc.com/wp-content/uploads/2025/09/Trusted-Remodeling-Company-400x284.webp",
        alt: "Lalo Construction Services Team",
      },
      aboutText: [
        "With years of experience in the industry, Lalo Construction Services brings reliability, professionalism, and passion to every project.",
        "From residential remodels to new commercial builds, we ensure every detail meets the highest standards.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Lalo Construction Services Logo",
      businessName: "Lalo Construction Services",
      contact: {
        phone: "6506794277",
        phoneLabel: "(650) 679-4277",
        email: "corneliopac@icloud.com",
        website: "https://caremodelingsvc.com/",
        address: "Oakland, CA 94621, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Oakland, CA 94621, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.316083663902!2d-122.210953!3d37.750231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f8701f16c662d%3A0x5b54c65c52e8a5c4!2sOakland%2C%20CA%2094621!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
